<script>
  //全局路径
  var globalPath = {
    api: "/api/", //主页调用接口地址
    downlaod: "/template/", //静态资源模版下载
    app: "/app/" //静态资源模版下载
  };
  let path;
  if (process.env.NODE_ENV === "development") {
    // dev
    path = "/base/"; //登陆页面接口地址
  } else {
    // build
    path = "/login/"; //登陆页面接口地址
  }
  globalPath.url = path;
  export default {
    globalPath
  };
</script>



// WEBPACK FOOTER //
// src/assets/script/globalPath.vue